export enum SignUpStep {
  Email = "email",
  Company = "company",
  Country = "country",
  YearsOpen = "yearsOpen",
  Revenue = "revenue",
  Vertical = "vertical",
  BusinessNeeds = "businessNeeds",
  CurrentSoftware = "currentSoftware",
  ContactInfo = "contactInfo",
  Free = "free",
  AccountConfirmation = "accountConfirmation",
  CreatePassword = "createPassword",
  Unsupported = "unsupported",
  Final = "final",
}
